import { useEffect, useState } from 'react';
import { getCustomizeCampaign } from '@fff-web/fff-utilities';

type CampaignResponse = {
  isLoadingNMC: boolean;
  hasNMCAccess: boolean;
  error: string | null;
};

const useCustomizeCampaignData = (): CampaignResponse => {
  const [hasNMCAccess, setNMCAccess] = useState(false);
  const [isLoadingNMC, setIsLoadingNMC] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const getCampaignData = async () => {
      try {
        const {
          userInfo: { customizePage },
        } = await getCustomizeCampaign({ newMember: true });
        setNMCAccess(
          customizePage === 'NEW_MEMBER_OPEN' || customizePage === 'NEW_MEMBER_OPEN_SOON',
        );
      } catch (_) {
        setError('Failed to fetch campaign data');
      } finally {
        setIsLoadingNMC(false);
      }
    };
    getCampaignData();
  }, []);

  return { isLoadingNMC, hasNMCAccess, error };
};

export default useCustomizeCampaignData;
